import React from 'react';
import { AttachmentsColumnsProps } from '../../../../../core/types/coreTypes';
import { useAppSelector } from '../../../../../store/hooks';
import { PermissionEnum } from '../../../../../core/enums/dictionariesEnums';
import usePermission from '../../../../../permissions-handling/permissionHook';
import AttachmentColumns from '../../../../../common/components/attachments-table/AttachmentColumns';
import { vehicleAttachmentsFiltersSelector } from '../../../../../store/selectors/vehiclesSelectors';
import { setVehicleAttachmentsFilters } from '../../../../../store/slices/vehiclesSlice';
import { useCoreAttachmentsColumns } from '../../../../../core/hooks/useCoreAttachmentsColumns';

const VehicleAttachmentsColumns: React.FC<AttachmentsColumnsProps> = ({
  isAll, checkAll, totalElements, indeterminate,
}) => {
  const allowedManage = usePermission(PermissionEnum.VehicleEditFields);
  const attachFilters = useAppSelector(vehicleAttachmentsFiltersSelector);

  const {
    searchVl,
    pickerValue,
    setPickerValue,
    sortHandle,
    onChangeSearchHandle,
    searchPressHandle,
    pickerHandle,
  } = useCoreAttachmentsColumns(attachFilters, setVehicleAttachmentsFilters);

  return (
    <AttachmentColumns
      allowedManage={!!allowedManage}
      isAll={isAll}
      indeterminate={indeterminate}
      checkAll={checkAll}
      totalElements={totalElements}
      sortHandle={sortHandle}
      onChangeSearchHandle={onChangeSearchHandle}
      searchPressHandle={searchPressHandle}
      searchVl={searchVl}
      tableFilters={attachFilters}
      pickerValue={pickerValue}
      setPickerValue={setPickerValue}
      pickerHandle={pickerHandle}
    />
  );
};

export default VehicleAttachmentsColumns;
